import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { SendMoneyDetail } from '../models/sendmoney/sendmoney';
import { UserGioLocation } from '../models/user/usergioLocation';
import { AlertService } from '../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../sharedcomponents/commonservice/countrylist.service';
import { geolocation } from '../sharedcomponents/commonservice/geolocation/geoloc';
import { utilityService } from '../sharedcomponents/commonservice/utility.service';
import { enumStatusCodeList, PaymentType } from '../sharedcomponents/_common/constants/app.constants';
import { ErrorPopupComponent } from '../sharedcomponents/_directive/error-popup/error-popup.component';
import { AgentStoreDetail } from '../_services/agentlocator/agentlocatorservice';
import { SendMoneyService } from '../_services/sendmoneyservice/sendmoneyservice';
@Component({
  selector: 'app-agentlocator',
  templateUrl: './agentlocator.component.html',
  styleUrls: ['./agentlocator.component.css'],
  providers: [AlertService, CountryService]
})
export class AgentLocatorComponent implements OnInit {
  PageFlow: any = {};
  sendMoneyDetail: SendMoneyDetail;
  storeCollection: any;
  model: any = {};
  loading = false;
  mapOptions: any;
  userGioLocation: UserGioLocation;
  constructor(
    private router: Router,
    private alertService: AlertService,
    private sendMoneyService: SendMoneyService,
    public utilityServ: utilityService,
    private modal: Modal,
    public geoloc: geolocation,
    private translate: TranslateService,
    private agentLocatorstoreserv: AgentStoreDetail
  ) {
    // this.sendMoneyService.getPageFlow().subscribe(data => {
    //   this.PageFlow = data;
    // });
    this.PageFlow.Value = sessionStorage.PageFlow;
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    this.userGioLocation = new UserGioLocation();
    this.utilityServ.busy = this.geoloc.getGioLocation().subscribe(data => {
      this.geoloc.setserGioLocation(this.userGioLocation)
      this.userGioLocation = data;
      this.loadStoresMap(this.userGioLocation);
    });
  }

  ngOnInit() {}

  loadStoresMap(userGioLocation: any) {
    this.mapOptions = {
      center: { lat: this.userGioLocation.latitude, lng: this.userGioLocation.longitude },
      zoom: 10,
      mapTypeId: 'roadmap',
      tilt: 45
    };
    const _self = this;

    this.utilityServ.busy = this.sendMoneyService.loadStoresInMap(true, userGioLocation).subscribe(
      data => {
        const resJSON = data;
        if (resJSON.Envelope.Body.StoresResponse.StatusCode == 20001) {
          return false;
        } else if (data.StatusCode == -10000) {
          let modalData: any = {};
          modalData.Title = _self.translate.instant('Common_lblOops').toString();
          modalData.Message = _self.translate.instant('Message_errorMessage').toString();
          this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
        } else if (resJSON.Envelope.Body.StoresResponse.StatusCode == enumStatusCodeList.SUCCESS) {
          _self.loading = false;
          let tempStoreCollection: any = this.utilityServ.getArray(resJSON.Envelope.Body.StoresResponse.Stores.StoreDetail);
          // below code not required
          // if (_self.sendMoneyDetail.currentCartDetail.CustmerPaymentMethod == PaymentType.PayAtStore) {
          //   _self.storeCollection = tempStoreCollection.filter(function(ele) {
          //     return _self.utilityServ.getObjectText(ele.StoreID) == _self.sendMoneyDetail.currentCartDetail.StoreId;
          //   });
          // } else {
          //   this.storeCollection = tempStoreCollection;
          // }

          this.storeCollection = tempStoreCollection;
          this.showRandomMarkers(this.storeCollection);
          //resJSON.Envelope.Body.GetStoreLocatorsResponse.GetStoreLocatorsResult.Stores.StoreDetail;
        } else {
          this.loading = false;
          // this.alertService.error(resJSON.Envelope.Body.StoresResponse.StatusMessage);
          let modalData: any = {};
          modalData.Title = this.translate.instant('Common_lblOops');
          modalData.Message = resJSON.Envelope.Body.StoresResponse.StatusMessage;
          this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
        }
      },
      error => {}
    );
  }

  positions = [];

  showRandomMarkers(markerCollection) {
    let randomLat: number, randomLng: number;
    this.positions = [];
    for (let markerCount = 0; markerCount < markerCollection.length; markerCount++) {
      // randomLat = Math.random() * 0.0099 + 43.7250;
      //randomLng = Math.random() * 0.0099 + -79.7699;
      // this.positions.push([randomLat, randomLng]);
      this.positions.push([this.utilityServ.getObjectText(markerCollection[markerCount].Address.Latitude), this.utilityServ.getObjectText(markerCollection[markerCount].Address.Longitude)]);
    }
  }
  onMarkerInit(marker) {
    //console.log('marker', marker);
  }
  callStore(phoneNumber) {
    const CountryObject: any = this.geoloc.getCountryObject();
    if (phoneNumber != undefined) {
      this.alertService.openErrorAlert(
        this.translate.instant('Common_lblInfo'),
        this.translate.instant('Message_lblCustomerCareContactPrefix') + ' ' + this.utilityServ.getObjectText(phoneNumber) + ' ' + this.translate.instant('Common_lblStoreContact')
      );
    } else {
      this.alertService.openErrorAlert(this.translate.instant('Common_lblInfo'), this.translate.instant('Message_customerCareError'));
    }
  }
  updateDiv(storeDetail) {
    this.agentLocatorstoreserv.setAgentDetail(storeDetail);
    this.router.navigate(['/agentlocatoragentdetail']);
    return;
  }

  openGoogleDirectionmap(c) {
    // window.open(
    //   `https://www.google.com/maps/dir/${this.userGioLocation.latitude},${this.userGioLocation.longitude}/${Number.parseFloat(c.Address.Latitude.__text)},${Number.parseFloat(
    //     c.Address.Longitude.__text
    //   )}`
    // );
    // window.open('https://www.google.com/maps?saddr=My+Location&daddr=' + Number.parseFloat(c.Address.Latitude.__text) + ',' + Number.parseFloat(c.Address.Longitude.__text));
    // window.open(
    //   'https://www.google.com/maps?saddr=My+Location&daddr=' +
    //     this.utilityServ.getObjectText(c.Address.Address1) +
    //     ' ' +
    //     this.utilityServ.getObjectText(c.Address.City) +
    //     ' ' +
    //     this.utilityServ.getObjectText(c.Address.StateCode) +
    //     ' ' +
    //     this.utilityServ.getObjectText(c.Address.CountryCode)
    // );
    //  window.open('https://www.google.com/maps?saddr=My+Location&daddr=' + c.Address.Address1);
    // https://www.google.com/maps?saddr=My+Location&daddr=43.12345,-76.12345
    // https://www.google.com/maps?saddr=41.6908605,-85.97&daddr=1216 W Bristol St, Elkhart, IN 46514, USA
    window.open(
      'https://www.google.com/maps/dir/?api=1&origin=My+Location&destination=' +
        this.utilityServ.getObjectText(c.Address.Address1) +
        ' ' +
        this.utilityServ.getObjectText(c.Address.City) +
        ' ' +
        this.utilityServ.getObjectText(c.Address.StateCode) +
        ' ' +
        this.utilityServ.getObjectText(c.Address.CountryCode)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/agentLocator/agentlocator.component.ts